import styles from './forward-arrow-link.module.scss'
import { ForwardArrowSvgIcon } from '../util/images'
import React from 'react'
import { Link } from 'react-router-dom'

interface ForwardArrowLinkProps {
  link: string
  text: string
  theme?: 'dark' | 'light'
}

export const ForwardArrowLink = ({ link, text, theme = 'dark' }: ForwardArrowLinkProps): React.ReactElement => {
  return (
    <Link
      to={link}
      className={`flex items-center gap-[10px] ${styles.container} ${theme === 'light' ? styles.light : styles.dark}`}
    >
      <span className={`font-roboto-condensed-medium text-sm leading-[23px] inline-block h-5 ${styles.text}`}>{text}</span>
      <ForwardArrowSvgIcon className={`w-5 h-5 flex-shrink-0 ${styles.arrow}`} />
    </Link>
  )
}
